import { NavigationOptions } from 'interfaces';
import AppRoutes from './routes';
import RolesEnum from './role';
import Icons from './icons';

/**
 * This file will hold the possible navigation options for the sidebar
 * like the header const file, initially can be only one const
 * that will be filtered based on user roles/permissions but
 * you can have other const and filter them
 */
export const clientManagementOptions: NavigationOptions[] = [
	{
		name: 'client-directory',
		label: 'Database',
		href: AppRoutes.LAWYERAPP_CLIENT_DIRECTORY,
		icon: Icons.setting5,
		roles: [RolesEnum.LAWYER],
	},
	{
		name: 'cleanup-wizard',
		label: 'Cleanup Wizard',
		href: AppRoutes.LAWYERAPP_CLIENT_DIRECTORY_CLEANUP_WIZARD,
		roles: [RolesEnum.LAWYER],
		icon: Icons.profileUsers,
	},
];

const cmsSidebarNavigation: NavigationOptions[] = [
	// ------------------ Client ------------------//
	{
		name: 'dashboard',
		label: 'Dashboard',
		href: AppRoutes.CLIENTAPP_DASHBOARD,
		icon: Icons.category,
		roles: [RolesEnum.CLIENT],
	},
	{
		name: 'my-cases',
		label: 'My Cases',
		href: AppRoutes.CLIENTAPP_MY_CASES,
		icon: Icons.briefcase,
		roles: [RolesEnum.CLIENT],
	},
	{
		name: 'all-cases',
		label: 'All Cases',
		href: AppRoutes.CLIENTAPP_ALL_CASES,
		icon: Icons.book,
		roles: [RolesEnum.CLIENT],
	},
	{
		name: 'financial-recovery',
		label: 'Financial',
		href: AppRoutes.CLIENTAPP_FINANCIAL_RECOVERY,
		icon: Icons.moneyReceive,
		roles: [RolesEnum.CLIENT],
	},
	{
		name: 'inbox',
		label: 'Inbox',
		href: AppRoutes.CLIENTAPP_INBOX,
		icon: Icons.sms,
		roles: [RolesEnum.CLIENT],
	},
	{
		name: 'claim-chat',
		label: 'Claim Chat',
		href: AppRoutes.CLIENTAPP_CLAIM_CHAT,
		icon: Icons.wand,
		roles: [RolesEnum.CLIENT],
		isMobile: true,
	},
	// ---------------- Lawyer ----------------//
	{
		name: 'dashboard',
		label: 'Dashboard',
		href: AppRoutes.LAWYERAPP_DASHBOARD,
		icon: Icons.category,
		roles: [RolesEnum.LAWYER],
	},
	{
		name: 'cases',
		label: 'Cases',
		href: AppRoutes.LAWYERAPP_CASES,
		icon: Icons.briefcase,
		roles: [RolesEnum.LAWYER],
	},
	{
		name: 'client-directory',
		label: 'Directory',
		href: AppRoutes.LAWYERAPP_CLIENT_DIRECTORY,
		icon: Icons.book,
		roles: [RolesEnum.LAWYER],
		subOptionTitle: 'Client Management',
		subOptions: clientManagementOptions,
	},
	{
		name: 'analytics',
		label: 'Analytics',
		href: AppRoutes.LAWYERAPP_CLIENT_ANALYTICS,
		icon: Icons.graph,
		roles: [RolesEnum.LAWYER],
	},
	{
		name: 'marketing',
		label: 'Marketing',
		href: AppRoutes.LAWYERAPP_MARKETING,
		icon: Icons.megaphone,
		roles: [RolesEnum.LAWYER],
		subOptionTitle: 'Campaign Management',
		subOptions: [
			{
				name: 'campaign',
				label: 'Campaign',
				href: AppRoutes.LAWYERAPP_MARKETING,
				icon: Icons.megaphone,
				roles: [RolesEnum.LAWYER],
			},
			{
				name: 'new-campaign',
				label: 'Create Campaign',
				href: AppRoutes.LAWYERAPP_MARKETING_NEW_CAMPAIGN,
				roles: [RolesEnum.LAWYER],
				icon: Icons.plus,
				isMobile: true,
			},
			{
				name: 'client-targeting',
				label: 'Retargeting',
				href: AppRoutes.LAWYERAPP_MARKETING_CLIENT_TARGETING,
				roles: [RolesEnum.LAWYER],
				icon: Icons.target,
			},
		],
	},
	// {
	// 	name: 'inbox',
	// 	label: 'Inbox',
	// 	href: AppRoutes.LAWYERAPP_INBOX,
	// 	icon: Icons.sms,
	// 	roles: [RolesEnum.LAWYER],
	// },
];

export default cmsSidebarNavigation;
